import { render, staticRenderFns } from "./ServiceTasks.vue?vue&type=template&id=fb0026ca&scoped=true&"
import script from "./ServiceTasks.vue?vue&type=script&lang=js&"
export * from "./ServiceTasks.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTasks.vue?vue&type=style&index=0&id=fb0026ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0026ca",
  null
  
)

export default component.exports